import { Container } from 'react-bootstrap';
import { useAuthState } from '../../hooks/useAuthState';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { DetailsListUsers } from './DetailsListUsers';

const UsersList = () => {
  const { userRoles } = useAuthState();
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    if (!userRoles || (!userRoles.isSuperAdmin && userRoles.adminIn.length < 1)) {
      navigate('/');
      return;
    }
  }, [navigate, userRoles]);

  return (
    <Container fluid>
      <h1 className='h1 mb-3'>{t('users.page-title')}</h1>
      <h4>{t('users.description')}</h4>

      <div style={{ width: '100%', marginTop: '.5rem' }}>
        <DetailsListUsers t={t} userRoles={userRoles} />
      </div>
    </Container>
  );
};

export default UsersList;
